<!-- Page 1 -->
<div class="pdf-page app-aul-010-24" id="aul01024">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-small" style="text-align: center">
    <b>FRAUD NOTICES</b>
    <br />
    <b
      >FOR YOUR PROTECTION STATE LAW REQUIRES THE FOLLOWING STATEMENT TO APPEAR
      ON THIS POLICY</b
    >
  </p>
  <p class="font-small">
    <b
      >ANY PERSON WHO KNOWINGLY AND WILLFULLY PRESENTS FALSE INFORMATION IN AN
      APPLICATION FOR INSURANCE MAY BE GUILTY OF INSURANCE FRAUD AND SUBJECT TO
      FINES AND CONFINEMENT IN PRISON.</b
    >
  </p>
  <p class="font-small">
    PLEASE REVIEW THE FOLLOWING STATE FRAUD NOTICES AS APPLICABLE TO THIS POLICY
  </p>
  <table
    id="aul-010-table1"
    class="font-small"
    style="border: 1px solid black; border-collapse: collapse"
  >
    <tbody>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Arkansas</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR
            PAYMENT OF A LOSS OR BENEFIT OR KNOWINGLY PRESENTS FALSE INFORMATION
            IN AN APPLICATION FOR INSURANCE IS GUILTY OF A CRIME AND MAY BE
            SUBJECT TO FINES AND CONFINEMENT IN PRISON.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Colorado</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            IT IS UNLAWFUL TO KNOWINGLY PROVIDE FALSE, INCOMPLETE, OR MISLEADING
            FACTS OR INFORMATION TO AN INSURANCE COMPANY FOR THE PURPOSE OF
            DEFRAUDING OR ATTEMPTING TO DEFRAUD THE COMPANY. PENALTIES MAY
            INCLUDE IMPRISONMENT, FINES, DENIAL OF INSURANCE, AND CIVIL DAMAGES.
            ANY INSURANCE COMPANY OR AGENT OF AN INSURANCE COMPANY WHO KNOWINGLY
            PROVIDES FALSE, INCOMPLETE, OR MISLEADING FACTS OR INFORMATION TO A
            POLICYHOLDER OR CLAIMANT FOR THE PURPOSE OF DEFRAUDING OR ATTEMPTING
            TO DEFRAUD THE POLICYHOLDER OR CLAIMANT WITH REGARD TO A SETTLEMENT
            OR AWARD PAYABLE FROM INSURANCE PROCEEDS SHALL BE REPORTED TO THE
            COLORADO DIVISION OF INSURANCE WITHIN THE DEPARTMENT OF REGULATORY
            AGENCIES.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">
          District of Columbia
        </td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            WARNING: IT IS A CRIME TO PROVIDE FALSE OR MISLEADING INFORMATION TO
            AN INSURER FOR THE PURPOSE OF DEFRAUDING THE INSURER OR ANY OTHER
            PERSON. PENALTIES INCLUDE IMPRISONMENT AND/OR FINES. IN ADDITION, AN
            INSURER MAY DENY INSURANCE BENEFITS IF FALSE INFORMATION MATERIALLY
            RELATED TO A CLAIM WAS PROVIDED BY THE APPLICANT.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Florida</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY AND WITH INTENT TO INJURE, DEFRAUD, OR
            DECEIVE ANY INSURER FILES A STATEMENT OF CLAIM OR AN APPLICATION
            CONTAINING ANY FALSE, INCOMPLETE, OR MISLEADING INFORMATION IS
            GUILTY OF A FELONY OF THE THIRD DEGREE.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Kansas</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            A "FRAUDULENT INSURANCE ACT" MEANS AN ACT COMMITTED BY ANY PERSON
            WHO, KNOWINGLY AND WITH INTENT TO DEFRAUD, PRESENTS, CAUSES TO BE
            PRESENTED OR PREPARES WITH KNOWLEDGE OR BELIEF THAT IT WILL BE
            PRESENTED TO OR BY AN INSURER, PURPORTED INSURER, BROKER OR ANY
            AGENT THEREOF, ANY WRITTEN, ELECTRONIC, ELECTRONIC IMPULSE,
            FACSIMILE, MAGNETIC, ORAL, OR TELEPHONIC COMMUNICATION OR STATEMENT
            AS PART OF, OR IN SUPPORT OF, AN APPLICATION FOR THE ISSUANCE OF, OR
            THE RATING OF AN INSURANCE POLICY FOR PERSONAL OR COMMERCIAL
            INSURANCE, OR A CLAIM FOR PAYMENT OR OTHER BENEFIT PURSUANT TO AN
            INSURANCE POLICY FOR COMMERCIAL OR PERSONAL INSURANCE WHICH SUCH
            PERSON KNOWS TO CONTAIN MATERIALLY FALSE INFORMATION CONCERNING ANY
            FACT MATERIAL THERETO; OR CONCEALS, FOR THE PURPOSE OF MISLEADING,
            INFORMATION CONCERNING ANY FACT MATERIAL THERETO.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 2 -->
<div class="pdf-page app-aul-010-24">
  <p class="font-medium" style="text-align: center"><b>FRAUD NOTICE</b></p>
  <p class="font-small">
    PLEASE REVIEW THE FOLLOWING STATE FRAUD NOTICES AS APPLICABLE TO THIS POLICY
  </p>
  <table
    class="font-small"
    style="border: 1px solid black; border-collapse: collapse"
  >
    <tbody>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Kentucky</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE
            COMPANY OR OTHER PERSON FILES AN APPLICATION FOR INSURANCE
            CONTAINING ANY MATERIALLY FALSE INFORMATION OR CONCEALS, FOR THE
            PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL
            THERETO COMMITS A FRAUDULENT INSURANCE ACT, WHICH IS A CRIME.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Louisiana</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR
            PAYMENT OF A LOSS OR BENEFIT OR KNOWINGLY PRESENTS FALSE INFORMATION
            IN AN APPLICATION FOR INSURANCE IS GUILTY OF A CRIME AND MAY BE
            SUBJECT TO FINES AND CONFINEMENT IN PRISON.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Maine</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            IT IS A CRIME TO KNOWINGLY PROVIDE FALSE, INCOMPLETE OR MISLEADING
            INFORMATION TO AN INSURANCE COMPANY FOR THE PURPOSE OF DEFRAUDING
            THE COMPANY. PENALTIES MAY INCLUDE IMPRISONMENT, FINES, OR DENIAL OF
            INSURANCE BENEFITS.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Maryland</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY OR WILLFULLY PRESENTS A FALSE OR FRAUDULENT
            CLAIM FOR PAYMENT OF A LOSS OR BENEFIT OR WHO KNOWINGLY OR WILLFULLY
            PRESENTS FALSE INFORMATION IN AN APPLICATION FOR INSURANCE IS GUILTY
            OF A CRIME AND MAY BE SUBJECT TO FINES AND CONFINEMENT IN PRISON.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">New Jersey</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO INCLUDES ANY FALSE OR MISLEADING INFORMATION ON AN
            APPLICATION FOR AN INSURANCE POLICY IS SUBJECT TO CRIMINAL AND CIVIL
            PENALTIES.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">New Mexico</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR
            PAYMENT OF A LOSS OR BENEFIT OR KNOWINGLY PRESENTS FALSE INFORMATION
            IN AN APPLICATION FOR INSURANCE IS GUILTY OF A CRIME AND MAY BE
            SUBJECT TO CIVIL FINES AND CRIMINAL PENALTIES.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">New York</td>
        <td style="border: 1px solid black; padding: 5px">
          <p><b>GENERAL:</b></p>
          <p>
            <b>
              ALL APPLICATIONS FOR COMMERCIAL INSURANCE, OTHER THAN AUTOMOBILE
              INSURANCE:</b
            >
            ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE
            COMPANY OR OTHER PERSON FILES AN APPLICATION FOR INSURANCE OR
            STATEMENT OF CLAIM CONTAINING ANY MATERIALLY FALSE INFORMATION, OR
            CONCEALS FOR THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY
            FACT MATERIAL THERETO, COMMITS A FRAUDULENT INSURANCE ACT, WHICH IS
            A CRIME, AND SHALL ALSO BE SUBJECT TO A CIVIL PENALTY NOT TO EXCEED
            FIVE THOUSAND DOLLARS AND THE STATED VALUE OF THE CLAIM FOR EACH
            SUCH VIOLATION.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 3 -->
<div class="pdf-page app-aul-010-24">
  <p class="font-medium" style="text-align: center"><b>FRAUD NOTICE</b></p>
  <p class="font-small">
    PLEASE REVIEW THE FOLLOWING STATE FRAUD NOTICES AS APPLICABLE TO THIS POLICY
  </p>
  <table
    class="font-small"
    style="border: 1px solid black; border-collapse: collapse"
  >
    <tbody>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Ohio</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO, WITH INTENT TO DEFRAUD OR KNOWING THAT HE IS
            FACILITATING A FRAUD AGAINST AN INSURER, SUBMITS AN APPLICATION OR
            FILES A CLAIM CONTAINING A FALSE OR DECEPTIVE STATEMENT IS GUILTY OF
            INSURANCE FRAUD.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Oklahoma</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            WARNING: ANY PERSON WHO KNOWINGLY, AND WITH INTENT TO INJURE,
            DEFRAUD OR DECEIVE ANY INSURER, MAKES ANY CLAIM FOR THE PROCEEDS OF
            AN INSURANCE POLICY CONTAINING ANY FALSE, INCOMPLETE OR MISLEADING
            INFORMATION IS GUILTY OF A FELONY.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Oregon</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY AND WILLFULLY PRESENTS FALSE INFORMATION IN
            AN APPLICATION FOR INSURANCE MAY BE GUILTY OF INSURANCE FRAUD AND
            SUBJECT TO FINES AND CONFINEMENT IN PRISON. THE AFOREMENTIONED
            ACTIONS MAY CONSTITUTE A FRAUDULENT INSURANCE ACT WHICH MAY BE A
            CRIME AND MAY SUBJECT THE PERSON TO PENALTIES.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Pennsylvania</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            <b
              >ALL COMMERCIAL INSURANCE, EXCEPT AS PROVIDED FOR AUTOMOBILE
              INSURANCE:</b
            >
            ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE
            COMPANY OR OTHER PERSON FILES AN APPLICATION FOR INSURANCE OR
            STATEMENT OF CLAIM CONTAINING ANY MATERIALLY FALSE INFORMATION OR
            CONCEALS FOR THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY
            FACT MATERIAL THERETO COMMITS A FRAUDULENT INSURANCE ACT, WHICH IS A
            CRIME AND SUBJECTS SUCH PERSON TO CRIMINAL AND CIVIL PENALTIES.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Puerto Rico</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            <b>
              ANY PERSON WHO KNOWINGLY AND WITH THE INTENTION OF DEFRAUDING
              PRESENTS FALSE INFORMATION IN AN INSURANCE APPLICATION, OR
              PRESENTS, HELPS, OR CAUSES THE PRESENTATION OF A FRAUDULENT CLAIM
              FOR THE PAYMENT OF A LOSS OR ANY OTHER BENEFIT, OR PRESENTS MORE
              THAN ONE CLAIM FOR THE SAME DAMAGE OR LOSS, SHALL INCUR A FELONY
              AND, UPON CONVICTION, SHALL BE SANCTIONED FOR EACH VIOLATION BY A
              FINE OF NOT LESS THAN FIVE THOUSAND DOLLARS ($5,000) AND NOT MORE
              THAN TEN THOUSAND DOLLARS ($10,000), OR A FIXED TERM OF
              IMPRISONMENT FOR THREE (3) YEARS, OR BOTH PENALTIES. SHOULD
              AGGRAVATING CIRCUMSTANCES [BE] PRESENT, THE PENALTY THUS
              ESTABLISHED MAY BE INCREASED TO A MAXIMUM OF FIVE (5) YEARS, IF
              EXTENUATING CIRCUMSTANCES ARE PRESENT, IT MAY BE REDUCED TO A
              MINIMUM OF TWO (2) YEARS.
            </b>
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Rhode Island</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR
            PAYMENT OF A LOSS OR BENEFIT OR KNOWINGLY PRESENTS FALSE INFORMATION
            IN AN APPLICATION FOR INSURANCE IS GUILTY OF A CRIME AND MAY BE
            SUBJECT TO FINES AND CONFINEMENT IN PRISON.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 4 -->
<div class="pdf-page app-aul-010-24">


  <p class="font-medium" style="text-align: center"><b>FRAUD NOTICE</b></p>
  <p class="font-small">
    PLEASE REVIEW THE FOLLOWING STATE FRAUD NOTICES AS APPLICABLE TO THIS POLICY
  </p>
  <table
    class="font-small"
    style="border: 1px solid black; border-collapse: collapse"
  >
    <tbody>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Tennessee</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            <b
              >ALL COMMERCIAL INSURANCE, EXCEPT AS PROVIDED FOR WORKERS’
              COMPENSATION: </b
            >IT IS A CRIME TO KNOWINGLY PROVIDE FALSE, INCOMPLETE OR MISLEADING
            INFORMATION TO AN INSURANCE COMPANY FOR THE PURPOSE OF DEFRAUDING
            THE COMPANY. PENALTIES INCLUDE IMPRISONMENT, FINES AND DENIAL OF
            INSURANCE BENEFITS.
          </p>
          <p>
            <b>WORKERS’ COMPENSATION: </b>IT IS A CRIME TO KNOWINGLY PROVIDE
            FALSE, INCOMPLETE OR MISLEADING INFORMATION TO ANY PARTY TO A
            WORKERS’ COMPENSATION TRANSACTION FOR THE PURPOSE OF COMMITTING
            FRAUD. PENALTIES INCLUDE IMPRISONMENT, FINES AND DENIAL OF INSURANCE
            BENEFITS.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Utah</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            WORKERS’ COMPENSATION: ANY PERSON WHO KNOWINGLY PRESENTS FALSE OR
            FRAUDULENT UNDERWRITING INFORMATION, FILES OR CAUSES TO BE FILED A
            FALSE OR FRAUDULENT CLAIM FOR DISABILITY COMPENSATION OR MEDICAL
            BENEFITS, OR SUBMITS A FALSE OR FRAUDULENT REPORT OR BILLING FOR
            HEALTH CARE FEES OR OTHER PROFESSIONAL SERVICES IS GUILTY OF A CRIME
            AND MAY BE SUBJECT TO FINES AND CONFINEMENT IN STATE PRISON.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Virginia</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            IT IS A CRIME TO KNOWINGLY PROVIDE FALSE, INCOMPLETE OR MISLEADING
            INFORMATION TO AN INSURANCE COMPANY FOR THE PURPOSE OF DEFRAUDING
            THE COMPANY. PENALTIES INCLUDE IMPRISONMENT, FINES AND DENIAL OF
            INSURANCE BENEFITS.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">Washington</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            IT IS A CRIME TO KNOWINGLY PROVIDE FALSE, INCOMPLETE OR MISLEADING
            INFORMATION TO AN INSURANCE COMPANY FOR THE PURPOSE OF DEFRAUDING
            THE COMPANY. PENALTIES INCLUDE IMPRISONMENT, FINES AND DENIAL OF
            INSURANCE BENEFITS.
          </p>
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 5px">West Virginia</td>
        <td style="border: 1px solid black; padding: 5px">
          <p>
            ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR
            PAYMENT OF A LOSS OR BENEFIT OR KNOWINGLY PRESENTS FALSE INFORMATION
            IN AN APPLICATION FOR INSURANCE IS GUILTY OF A CRIME AND MAY BE
            SUBJECT TO FINES AND CONFINEMENT IN PRISON.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

